(function ($) {
  $.fn.equalHeights = function () {
    var h  = 0;
    var $elems = this.css('height', '').each(function () {
      h = Math.max(h, $(this).outerHeight());
    });
    return !h ? $elems : $elems.outerHeight(h);
  };
})(jQuery);
